export default __webpack_public_path__ + "static/media/CK-cover.cfe25c75.jpg";